// Подключаемая вёрстка

export default ({ cls = '', count = 0 } = {}) => [
  {block: 'slider-pagination', cls, content: [
      {elem: 'swiper-pagination', cls: 'swiper-pagination', content: [...new Array(count)].map(() => [
          {cls: 'swiper-pagination-bullet'},
        ])},
      {elem: 'scroll'}
    ]},
];

